var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 387,
    height: 387,
    viewBox: "0 0 387 387",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M315.424 62.2078L300.259 47.0434C285.91 32.6939 260.895 32.6939 246.546 47.0434L180.42 113.497C165.61 128.307 165.61 152.4 180.42 167.21L195.585 182.375C202.759 189.549 212.296 193.5 222.441 193.5C232.586 193.5 242.123 189.549 249.298 182.375L315.424 115.921C330.234 101.111 330.234 77.0179 315.424 62.2078Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.844 24.1875C75.5062 24.1875 48.375 51.3187 48.375 84.6562C48.375 117.993 75.5062 145.125 108.844 145.125C142.181 145.125 169.312 117.993 169.312 84.6562C169.312 51.3187 142.181 24.1875 108.844 24.1875ZM149.4 64.7441L101.025 113.119C99.8443 114.3 98.2971 114.891 96.75 114.891C95.2029 114.891 93.6557 114.3 92.4747 113.119L68.2872 88.9316C65.9251 86.5695 65.9251 82.743 68.2872 80.3809C70.6492 78.0189 74.4758 78.0189 76.8378 80.3809L96.75 100.293L140.85 56.1934C143.212 53.8314 147.038 53.8314 149.4 56.1934C151.762 58.5555 151.762 62.382 149.4 64.7441Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M223.734 229.781L190.995 197.042C188.727 194.774 185.651 193.5 182.444 193.5H139.078L175.359 229.781H223.734Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4688 235.828L24.1875 199.547V315.475C24.1875 318.682 25.4617 321.759 27.7297 324.027L60.4688 356.766V235.828Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M146.897 267.834L133.031 281.699V241.875H169.312V281.699L155.447 267.834C153.085 265.472 149.259 265.472 146.897 267.834Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M120.938 241.875V296.297C120.938 298.742 122.408 300.95 124.67 301.883C125.42 302.19 126.205 302.344 126.984 302.344C128.555 302.344 130.102 301.73 131.26 300.572L151.172 280.66L171.084 300.572C172.814 302.297 175.413 302.804 177.674 301.883C179.936 300.95 181.406 298.742 181.406 296.297V241.875H229.781V350.719C229.781 357.397 224.366 362.812 217.688 362.812H72.5625V241.875H120.938Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6094 193.5L114.891 229.781H66.5156L30.2344 193.5H78.6094Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M126.984 193.5L163.266 229.781H126.984L90.7031 193.5H126.984Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M355.298 185.986L308.916 139.604L272.727 175.977L319.017 222.267C329.036 232.286 345.279 232.286 355.298 222.267C365.317 212.248 365.317 196.004 355.298 185.986Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.9925c212ec0181748e8056d72c61ed1f.svg";
export { ForwardRef as ReactComponent };